module.exports = __webpack_public_path__ + "media/images/logo-a82c535c8f44389433a91d7ce93dffeb.svg";